<template>
    <div 
        :class="{'has-footer': hasFooter}" 
        id="app" 
        class="position-relative" 
        :style="`background: ${ecommercePagesBackgroundColors}; min-height: 100vh;`" 
        ref="crosspromApp" 
        data-version="1.2.0"
    >
        <!-- <Loader v-if="premiumPlanSelected" /> -->
        <div style="overflow: auto">
            <div v-if="authLoading === false">
                <HeaderLogin 
                    :landing-page="true" v-if="isLoggedIn"
                    dashboard: dashboard
                    />
                <HeaderGuest :landing-page="true" v-else/>
                <div class="page-content"
                    :class="{
                        'no-vertical-scroll': isEcommercePlatform && $route.meta.fullPgae || !isEcommercePlatform,
                        'ecommerce-edit': $route.name === 'edit-shop' && isEcommercePlatform,
                        'ecommerce-platform': isEcommercePlatform,
                        'ecommerce-wizard': $route.name === 'edit-shop' && isEcommercePlatform,
                        'ecommerce-singleshop': $route.name === 'single-shop' && isEcommercePlatform,
                        'ecommerce-landing': $route.name === 'ecommercelandingpage' && isEcommercePlatform
                    }">
                    <router-view/>
                </div>
            </div>
            

            <div class="loading pt-5" v-else>
                <Loader class="pt-5"/>
            </div>
            <MobileView />

            <Footer v-if="authLoading === false" @toggleFooter="toggleFooter"/>

            <!-- MODALS -->
            <CpRequest
                    v-if="modals['cp-request']"/>
            <Login
                    v-if="modals['login']"/>
            <SignUp
                    v-if="modals['sign-up']"/>
            <EmailConfirmReg
                    v-if="modals['confirm-reg']"/>
            <CampSuccess
                    v-if="modals['camp-success']"/>
            <PassChangeSuccessful
                    v-if="modals['pass-change']"/>
            <ChangePassPop
                    v-if="modals['pass-pop']"/>
            <ForgotPassword
                    v-if="modals['forgot-pass']"/>
            <SharableContent
                    v-if="modals['sharable-content']"/>
            <SuccessModal
                    v-if="modals['success-modal']"/>
            <PendingsModal
                    v-if="modals['pendings-modal']"/>
            <OutOfBeta
                    v-if="modals['out-of-beta']"/>
            <ProcessingKickstarterDraft
                    v-if="modals['processing-kickstarter-draft']"/>
            <SendMessageModal 
                    v-if="modals['send-message-modal']"/>
        </div>
    </div>
</template>


<script>
import { mapState } from 'vuex'
import moment from 'moment'
import HeaderLogin from '@/components/HeaderLogin/index.vue'
import HeaderGuest from '@/components/HeaderGuest.vue'
import Footer from '@/components/Footer.vue'
import CpRequest from '@/components/CpRequest/modal.vue'
import Login from './popups/LogIn'
import SignUp from './popups/SignUp'
import EmailConfirmReg from './popups/EmailConfirmReg'
import ForgotPassword from './popups/ForgotPassword'
import ChangePassPop from './popups/ChangePassPop'
import CampSuccess from './popups/CampSuccess'
import PassChangeSuccessful from './popups/PassChangeSuccessful'
import SharableContent from './popups/SharableContent'
import UnsavedChanges from './popups/UnsavedChanges'
import SuccessModal from './popups/SuccessModal'
import SendMessageModal from './popups/SendMessageModal'
import ProcessingKickstarterDraft from './popups/ProcessingKickstarterDraft'
import PendingsModal from './popups/PendingsModal/index'
import OutOfBeta from './popups/OutOfBeta'
import { message } from 'ant-design-vue'
import * as firebase from "firebase"
import { Loader } from './components/Icons'
import MobileView from "./views/MobileView";
import {UserService} from './core/services'
import Alert from './components/Theme/Alert'
import {useStripe, useStore, useRouter} from './core/hooks'
import {onMounted, onUnmounted, computed, watch, ref} from '@vue/composition-api'

export default {
    components: {
        HeaderLogin,
        HeaderGuest,
        Footer,
        CpRequest,
        Login,
        SignUp,
        EmailConfirmReg,
        CampSuccess,
        SharableContent,
        PassChangeSuccessful,
        ChangePassPop,
        ForgotPassword,
        UnsavedChanges,
        Loader,
        MobileView,
        SuccessModal,
        SendMessageModal,
        Alert,
        PendingsModal,
        OutOfBeta,
        ProcessingKickstarterDraft
    },
    setup(props, {root}){
        const {store, state} = useStore()
        const {route, router} = useRouter()
        const {redirectToCheckout} = useStripe()

        const authPending = computed(() =>  state.value.user === null)
        const isLoggedIn = computed(() => state.value.user && state.value.idToken)
        const dashboard = computed(() => route.value.path.includes('/dashboard'))
        const isVerifiedUser = computed(() => state.value.user && state.value.user.verified)
        const trialTimeRemaining = computed(() => state.value.user.trialTimeRemaining)
        const inPremium = computed(() => store.getters.inPremium)
        const modals = computed(() => state.value.modals)
        const hasFooter = ref(true)
        const verifiedWithUrl = ref(false)

        const premiumPlanSelected = computed(() => state.value.user && state.value.user.chosenPlanOnSignup && state.value.user.chosenPlanOnSignup.name === 'premium' && state.value.user.chosenPlanOnSignup.priceId)
        const isEcommercePlatform = computed(() => store.getters.isEcommercePlatform)
        const authLoading = ref(null)

        const ecommercePagesBackgroundColors = computed(() => {
            if(isEcommercePlatform.value) {
                switch(route.value.name) {
                    case 'add-shop':
                        return '#E2E8F0';
                    case 'edit-shop':
                        return '#F4F7FA';
                    case 'single-shop': 
                        return '#F4F7FA';
                    default: 
                        return '#FFFFFF'
                }
            }
        })
        const toggleFooter = (isMobileDevice) => {
            hasFooter.value = !isMobileDevice
        }

        const verifyEmailCode = () => {
            return firebase
                .auth()
                .applyActionCode(route.value.query.oobCode)
        }

        const pendingsModalOpen = () => {
            if(store.state.user && store.state.user.uid) {
                const pendingModal = JSON.parse(localStorage.getItem('pendingModal'))
                if(!pendingModal) {
                    localStorage.setItem(
                        'pendingModal', JSON.stringify(
                            {
                                showedTime: Date.now()
                            }
                        )
                    )
                    return store.commit('TOGGLE_MODAL', ['pendings-modal', true])
                }
                if(Math.abs(moment().diff(pendingModal.showedTime, 'hours')) >= 24) {
                    store.commit('TOGGLE_MODAL', ['pendings-modal', true])
                }
            }
            return false
        }

        const setupMixpanelProfile = (providerId) => {
            const profileProperties = [
                store.state.user.email, 
                store.state.user.name, 
                providerId
            ]

            if(!isEcommercePlatform.value) {
                profileProperties.push(store.state.user.chosenPlanOnSignup === 'paid')
            }

            root.$setUpMixpanelUser(...profileProperties)
        }

        onUnmounted(() => {
            window.removeEventListener('storage', () => {})
        })

        onMounted( async () => {
            // auto login and logout for the browser's other tabs
            window.addEventListener('storage', function(event) { 
                if (event.key === 'authenticated') {
                    setTimeout(() => {
                        return location.reload()
                    }, 1500)
                }
                
            });

            if(!isEcommercePlatform.value) {
                await store.dispatch('getStripeKeys')
            }

            if (route.value.query.oobCode && route.value.query.mode === 'verifyEmail') {
                try {
                    const res = await verifyEmailCode()
                    verifiedWithUrl.value = true
                }  catch(err) {
                    message.error(err.message)
                    if (!route.value.query.continueUrl){
                        router.push('/').catch(() => {})
                    }
                } finally{
                    if (route.value.query.continueUrl){
                        return window.location.href = route.value.query.continueUrl+'/browse'
                    }
                }

                debugger

                router.replace({
                    query: {
                        ...route.value.query,
                        mode: undefined,
                        oobCode: undefined,
                        apiKey: undefined,
                        lang: undefined
                    }
                })
                .catch(() => {})
            }

            

            try {

                authLoading.value = true
                const resp = await store.dispatch('auth')
                authLoading.value = false

                if (!route.value.meta.public && !resp.authenticated) {
                    message.error('Please login to proceed!')
                    return router.push('/').catch(() => {})
                }

                const mixpanelUserId = root.$getMixpanelUserId()
                if(route.value.query.refId && !resp.authenticated) {
                    store.commit('TOGGLE_MODAL', ['sign-up', true])
                }

                if(resp.authenticated){

                    const userRef = UserService.getUserDoc(store.getters.usersCollection, store.state.user.userId)

                    if(!mixpanelUserId) {
                        if(store.state.user.hasMixpanelProfile){
                            root.$identifyMixpanelUser(store.state.user.email)
                        } else {
                            const providerId = resp.user.providerData[0].providerId // either google.com or password
                            userRef.update({
                                hasMixpanelProfile: true
                            })

                            setupMixpanelProfile(providerId)
                        }
                    }

                    if(!isEcommercePlatform){
                        pendingsModalOpen()
                    }
                    
                    if(state.value.user.chosenPlanOnSignup && state.value.user.chosenPlanOnSignup.name === 'premium' && state.value.user.chosenPlanOnSignup.priceId) {
                        authLoading.value = true
                        userRef.update({
                            'chosenPlanOnSignup.priceId': null,
                        })

                        redirectToCheckout({
                            stripeInstance: root.$stripe,
                            priceId: store.state.user.chosenPlanOnSignup.priceId
                        })
                        return 
                    }

                    if(route.value.query['checkout-success']) {
                        let message = `Your membership is activated!`
                        if(route.value.query['days']){
                            message = `Your membership is activated for ${route.value.query['days']} days!`
                        }
                        store.commit('TOGGLE_MODAL', ['success-modal', {
                            title: message,
                            btnText: 'Next'
                        }]);

                        root.$ga.event('Pricing','Checkout Completed')
                        root.$sendMixpanelEvent('Checkout Completed');
                    }

                    if(route.value.query['checkout-canceled']) {
                        message.error(`
                            Checkout wasn't completed. 
                            You can resume membership purchase from the Pricing page.`
                        , 5)
                        root.$ga.event('Pricing',"Checkout Wasn't Completed")
                        root.$sendMixpanelEvent("Checkout Wasn't Completed");
                    }

                    if(route.value.query['update-payment-canceled']) {
                        message.error('Your payment data is not updated', 3)
                    }

                }
            } catch(e) {
                console.log(e)
            }
        })


        watch([route], ([route]) => {
            if (!route.meta.public && !store.state.user) {
                message.error('Please login to proceed!')
                router.push('/').catch(() => {})
            }
        })

        return {
            authPending,
            isLoggedIn,
            dashboard, 
            isVerifiedUser,
            trialTimeRemaining,
            modals,
            premiumPlanSelected,
            authLoading,
            toggleFooter,
            hasFooter,
            inPremium,
            isEcommercePlatform,
            ecommercePagesBackgroundColors
        }
        
    },
    
}
</script>
<style src="./assets/App.scss" lang="scss">
    .loading {
        height: 100vh;
        background: #000;
        color: white;
        width: 100%;
    }
</style>

<style scoped lang="scss">
    .has-footer {
        padding-bottom: 60px
    }
    .no-vertical-scroll {
        display: flex; 
        flex-direction: column;
        justify-content: center
    }

    .page-content {
        padding-top: 30px;

        &.no-vertical-scroll {
            padding-top: 0;
        }
        &.ecommerce-edit {
            padding-bottom: 30px;
        }
        &.ecommerce-singleshop {
            min-height: calc(100vh - 120px);
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 30px 0;
        }
        &.ecommerce-landing {
            padding: 0;
        }
    }
</style>



